/** Lead capture for the UAE sustainability assessment (isolated from /contact). */

export const ASSESSMENT_LEAD_ENDPOINT = '/api/assessment-lead'

export const ASSESSMENT_LEAD_SOURCE = 'uae-sustainability-assessment'

export const ASSESSMENT_LEAD_FORM_TYPE = 'assessment-lead'
